/** removes milliseconds from datestamp, for shorter x-axis labels */
function dateStampTrimmer() {
  return this.value.slice(0, -4);
}

export default (data, rssiUnit) => {
  return {
    chart: {
      type: "line",
      zoomType: "x",
    },
    title: {
      text: "RSSI Report",
    },
    xAxis: {
      type: "category",
      title: {
        text: "Reports (Oldest -> Newest)",
      },
      labels: {
        align: "right",
        rotation: -20,
        formatter: dateStampTrimmer,
      },
    },
    yAxis: {
      title: {
        text: "RSSI Reading",
      },
      min: -100,
      max: 0,
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: [
      {
        type: "line",
        name: rssiUnit,
        /*
          Received Signal Strength Indicator: It measure the signal strength.
          RSSI is a term used to measure the relative quality of a received signal to a client device, but has no absolute value.
         */
        data: data,
      },
    ],
  };
};
